import * as React from "react";
const SvgFiRrUserMd = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-user-md_svg__a)">
      <path
        fill="#062147"
        d="M12 12c3.309 0 6-2.691 6-6s-2.691-6-6-6-6 2.691-6 6 2.691 6 6 6m0-10c2.206 0 4 1.794 4 4s-1.794 4-4 4-4-1.794-4-4 1.794-4 4-4m10 21a1 1 0 1 1-2 0 7.01 7.01 0 0 0-4-6.324v2.496c1.164.413 2 1.524 2 2.828v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-2 0v1a1 1 0 1 1-2 0v-1c0-1.304.836-2.415 2-2.828v-3.1A7 7 0 0 0 13 16h-2c-.695 0-1.366.102-2 .292v2.977a1.999 1.999 0 0 1-1 3.732 2 2 0 0 1-1-3.732V17.26a7 7 0 0 0-3 5.741 1 1 0 1 1-2 0c0-4.963 4.037-9 9-9h2c4.963 0 9 4.036 9 8.999"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-user-md_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrUserMd;
